import { useState } from "react";

import { useAuthApi } from "@/lib/api/auth/useAuthApi";
import { resetAuthState } from "@/lib/hooks/useAuth";

export const useLogoutModal = () => {
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [isLogoutModalOpened, setIsLogoutModalOpened] = useState(false);
  const { logout } = useAuthApi();

  const handleLogout = async () => {
    setIsLoggingOut(true);

    try {
      await logout();
    } catch (e) {
      console.error("Failed to logout:", e);
    }

    resetAuthState();

    window.location.href = "/";

    setIsLoggingOut(false);
  };

  return {
    handleLogout,
    isLoggingOut,
    isLogoutModalOpened,
    setIsLogoutModalOpened,
  };
};
